import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { isEmpty } from 'lodash';
import {
  DropdownIndicator,
  IndicatorSeparator,
  getTranslatedText,
  useSiteListForDropdown
} from '@nile/components';
import { AccountClient, GET_CLIENTS } from '@nile/graphql';
import { injectIntl } from 'react-intl';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

const DynamicField = (props) => {
  const { options, name, label } = props.field;

  const { value, intl, isClearable = false } = props;
  const isITProduct = useCheckIsItProduct();

  const { dependentFieldId, dependentFieldName } = props.config;

  const [dropdownOptions, setDropdownOptions] = useState([]);

  const [selected, setSelected] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (option) => {
    setSelected(option);
    switch (name) {
      case 'client':
        props.handleChange({
          accountId: isEmpty(option) ? null : option?.id,
          name: isEmpty(option) ? null : option?.value,
          fieldName: 'client',
          isDynamic: true
        });
        break;
      case 'site':
        props.handleChange({
          id: isEmpty(option) ? null : option.id,
          name: isEmpty(option) ? null : option.value,
          fieldName: 'site',
          isDynamic: true
        });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (!isEmpty(value)) {
      setSelected({
        label: value,
        value
      });
    }
  }, [value]);
  const { getClientSites, data: sites } = useSiteListForDropdown();

  useEffect(() => {
    if (sites) {
      const siteOptions = [];
      sites.forEach((el) => {
        siteOptions.push({
          label: el.name,
          value: el.name,
          id: el.id
        });
      });
      if (value) {
        setSelected({
          label: value,
          value
        });
      }
      setDropdownOptions(siteOptions);
      setLoading(false);
    }
  }, [sites]);

  const populateOptions = () => {
    setLoading(true);
    const processedOptions = [];
    switch (name) {
      case 'client':
        AccountClient.query({
          query: GET_CLIENTS,
          variables: {
            listInfo: {
              sort: {
                attribute: 'name',
                order: 'ASC'
              }
            }
          }
        }).then((res) => {
          if (res?.data?.getClientList) {
            res.data.getClientList.clients.forEach((el) => {
              processedOptions.push({
                label: el.name,
                value: el.name,
                id: el.accountId
              });
            });
          }
          setLoading(false);
        });
        break;
      case 'site':
        if (dependentFieldId) {
          getClientSites(dependentFieldId);
        }
        if (isITProduct && !dependentFieldId) {
          getClientSites();
        }
        break;
      default:
        break;
    }
    setDropdownOptions(processedOptions);
  };

  useEffect(() => {
    populateOptions();
  }, [options]);

  useEffect(() => {
    if (dependentFieldName && dependentFieldId) {
      setSelected('');
      populateOptions();
    }
  }, [dependentFieldName, dependentFieldId]);

  const getDisableStatus = () => {
    if (dependentFieldName) {
      switch (dependentFieldName) {
        case 'client':
          if (dependentFieldId) {
            return false;
          }
          return true;
        default:
          break;
      }
    }
    return false;
  };

  const renderSelectField = () => {
    return (
      <div>
        <div className="">{getTranslatedText(intl, label)}</div>
        <Select
          className="w100"
          classNamePrefix="value_selector"
          key={selected}
          isLoading={loading}
          defaultValue={selected}
          isDisabled={getDisableStatus()}
          components={{ IndicatorSeparator, DropdownIndicator }}
          onChange={handleChange}
          options={dropdownOptions}
          placeholder={'Choose value'}
          menuPortalTarget={document.body}
          menuPlacement="auto"
          isClearable={isClearable}
          closeMenuOnScroll={(e) => {
            e.stopPropagation();
            e.preventDefault();
            return (
              e.target &&
              e.target.classList &&
              !(e.target.classList.value.indexOf('menu-list') > -1)
            );
          }}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 })
          }}
        />
      </div>
    );
  };

  const renderField = () => {
    switch (name) {
      case 'client':
      case 'site':
        return renderSelectField();
      case 'model':
      case 'assetMake.name':
        return <input type="text" placeholder="Testing" />;
      default:
        break;
    }
  };

  return <div className="w100 mb10">{renderField()}</div>;
};

export default injectIntl(DynamicField);
